module.exports = __webpack_public_path__ + "static/foryou-whole-plants.6a6fc13a.jpg";